// nextjs-auth0's default session cookie name, which the classic client keeps.
const CLASSIC_AUTH0_SESSION_COOKIE = '__session';

// A large session is split into `__session__0`, `__session__1`, … (older SDKs used `__session.0`).
const CHUNKED_SESSION_COOKIE = /^__session(__|\.)\d+$/;

export const hasClassicAuth0SessionCookie = (cookies: Record<string, string> | undefined): boolean =>
	Object.entries(cookies ?? {}).some(
		([name, value]) =>
			Boolean(value) && (name === CLASSIC_AUTH0_SESSION_COOKIE || CHUNKED_SESSION_COOKIE.test(name)),
	);
